import { SDS_SPACE_XSMALL } from '@s-group/design-system-tokens/web/tokens/space.es6.js';
import { css } from 'styled-components';
import { Collapsible } from '../Collapsible/Collapsible.js';

const CollapsibleGroupStyle = css `
    flex: 1;

    ${Collapsible} {
        margin-bottom: ${({ alternative }) => alternative ? SDS_SPACE_XSMALL : 0};

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export { CollapsibleGroupStyle };
//# sourceMappingURL=CollapsibleGroup.styles.js.map
